import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { organizationSettingsService } from "@/services/organizationSettings.service/organizationSettings.api";
import { Github } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export default function GithubReposSettings() {
  const [reposText, setReposText] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      const [data, err] = await organizationSettingsService.getGithubRepos();
      if (cancelled) return;
      if (err || !data) {
        toast.error(err?.msg || "Não foi possível carregar os repositórios do GitHub");
        setLoading(false);
        return;
      }
      setReposText((data.githubRepos || []).join("\n"));
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  async function handleSave() {
    const githubRepos = reposText
      .split("\n")
      .map((url) => url.trim())
      .filter(Boolean);
    setSaving(true);
    const [data, err] = await organizationSettingsService.updateGithubRepos(githubRepos);
    setSaving(false);
    if (err || !data) {
      toast.error(err?.msg || "Erro ao salvar repositórios do GitHub");
      return;
    }
    setReposText((data.githubRepos || []).join("\n"));
    toast.success("Repositórios do GitHub salvos!");
  }

  return (
    <div className="space-y-4">
      <div>
        <h3 className="flex items-center gap-2 text-base font-semibold">
          <Github className="h-4 w-4" />
          Repositórios do GitHub
        </h3>
        <p className="mt-1 text-sm text-muted-foreground">
          URLs de repositórios vinculados à organização inteira — só referência, um por linha
          (não há integração com a API do GitHub). Pra vincular um repositório a um projeto
          específico de uma empresa, edite o projeto em Empresas → Projetos.
        </p>
      </div>

      {loading ? (
        <p className="text-sm text-muted-foreground">Carregando…</p>
      ) : (
        <Textarea
          value={reposText}
          onChange={(e) => setReposText(e.target.value)}
          placeholder={"https://github.com/org/repo-1\nhttps://github.com/org/repo-2"}
          rows={6}
        />
      )}

      <Button onClick={handleSave} disabled={loading || saving}>
        {saving ? "Salvando..." : "Salvar"}
      </Button>
    </div>
  );
}
